
const ImageGallery = (target) => {
  const productView = target.querySelector(".product__view");
  if (!productView) {
    return;
  }

  const mainImage = productView.querySelector(".product__image img");
  if (!mainImage) {
    return;
  }

  const imageThumbnails = productView.querySelectorAll(".product__image-thumbnail");

  const method = {
    init: () => {
      imageThumbnails.forEach((thumb) => {
        thumb.addEventListener("click", method.onClick);
      });
    },
    onClick: (e) => {
      const targetImage = e.target;
      const imageUrl = targetImage.getAttribute("data-imageUrl");

      method.cleanupClasses();
      targetImage.classList.add("product-image--selected");
      mainImage.src = imageUrl;
      mainImage.alt = targetImage.alt;
    },
    cleanupClasses: () => {
      imageThumbnails.forEach((thumb) => {
        thumb.classList.remove("product-image--selected");
      });
    },
  };

  method.init();
};

export default ImageGallery;
